import React from "react";
import { NewEmployeeEligibilityReportContainer } from "../../../containers";

const NewEmployeeEligibilityReport = (props) => {
  return <NewEmployeeEligibilityReportContainer {...props} />;
};

export default NewEmployeeEligibilityReport;
